var borders_default = {
  "borderT": "_9X4At",
  "borderB": "iPKOK",
  "borderL": "KXfTt",
  "borderR": "SxBtR",
  "borderColorOverride": "-DfC-"
};
export {
  borders_default as default
};
//# sourceMappingURL=borders-scss.js.map
